module.exports = function() {
  return new Worker("/" + "coffee-transpiler.b825d17e.worker.js");
};